/*
 *
 * userAPI.js
 *
 */

import Axios from "axios";

const userAPI = {
  fetchAll: async () => await Axios.get(`${window.API_URL}/user/get.php`),
  create: async (data) =>
    await Axios.post(`${window.API_URL}/user/create.php`, {
      username: data.username,
      role: data.role,
      password: data.password,
      email: data.email,
      sendEmail: data.sendEmail,
      firstname: data.firstname,
      lastname: data.lastname,
    }),
  delete: async (data) =>
    await Axios.post(`${window.API_URL}/user/delete.php`, {
      userID: data.userID,
    }),
  setActive: async (data) =>
    await Axios.post(`${window.API_URL}/user/setActive.php`, {
      userIDs: data.userIDs,
      active: data.active,
    }),
  setPassword: async (data) =>
    await Axios.post(`${window.API_URL}/user/setPassword.php`, {
      userID: data.userID,
      password: data.password,
      sendEmail: data.sendEmail,
    }),
  saveModifications: async (data) =>
    await Axios.post(`${window.API_URL}/user/saveModifications.php`, {
      ID: data.ID,
      userName: data.userName,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      role: data.role,
      active: data.active,
    }),
};

export default userAPI;
